import { render, staticRenderFns } from "./ComplaintTypeManage.vue?vue&type=template&id=71b81bfa&"
import script from "./ComplaintTypeManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports